import {
  BNPL_BREAKPOINT_LG,
  BNPL_PDP_MESSAGING_FONT_SIZE,
  BNPL_WIDGET_STYLE,
} from '@amblique/king-living/app/constants/bnpl-messaging';
import {A11Y_FOCUS_VISIBLE} from '@amblique/king-living/app/theme/foundations/a11y-focus-visible';

const {AFTERPAY_LOGO_BADGE_WIDTH, FONT_SIZE, INFO_ICON_SIZE, LOGO_HEIGHT} = BNPL_WIDGET_STYLE;

const inCartFooter = '.cart-flyout__footer &';
const inPdpPaymentMethods = '.pdp-payment-methods &';

const BuyNowPayLaterMessaging = {
  parts: ['root', 'afterpayWidget', 'zipWidget'],
  baseStyle: {
    root: {
      alignItems: 'flex-start',
      display: 'flex',
      flexDirection: 'column',
      gap: '11px',
      textAlign: 'left',
      width: '100%',
      sx: {
        [inCartFooter]: {
          alignItems: 'center',
          textAlign: 'center',
        },
      },
    },
    afterpayWidget: {
      sx: {
        'alignItems': 'center',
        'color': 'grayAlpha.90',
        'display': 'block',
        'fontFamily': 'body',
        'fontSize': BNPL_PDP_MESSAGING_FONT_SIZE,
        'fontWeight': 'normal',
        'justifyContent': 'flex-start',
        'lineHeight': '120%',
        'minHeight': 'auto',
        'width': '100%',
        [inPdpPaymentMethods]: {
          'paddingLeft': '12px',
          'position': 'relative',
          '&::before': {
            backgroundColor: 'grayAlpha.90',
            borderRadius: '50%',
            content: '""',
            height: '4px',
            left: 0,
            position: 'absolute',
            top: '8px',
            width: '4px',
          },
        },
        [inCartFooter]: {
          'color': 'greyscale.100',
          'fontSize': FONT_SIZE,
          'justifyContent': {base: 'center', lg: 'flex-start'},
          'paddingLeft': 0,
          '&::before': {
            display: 'none',
          },
        },
        '& square-placement': {
          '--logo-badge-width': AFTERPAY_LOGO_BADGE_WIDTH,
          '--messaging-font-size': BNPL_PDP_MESSAGING_FONT_SIZE,
          'marginBottom': 0,
          'marginLeft': 0,
          'marginRight': 0,
          'marginTop': '0 !important',
          'width': '100%',
          [inCartFooter]: {
            '--messaging-font-size': FONT_SIZE.base,
            'display': 'inline-flex',
            'marginTop': '-4px !important',
            'marginBottom': '4px',
            'marginLeft': {base: 'auto', lg: '0'},
            'marginRight': {base: 'auto', lg: '0'},
            [`@media (min-width: ${BNPL_BREAKPOINT_LG})`]: {
              '--messaging-font-size': FONT_SIZE.lg,
            },
          },
        },
      },
    },
    zipWidget: {
      sx: {
        'alignItems': 'center',
        'color': 'grayAlpha.90',
        'display': 'flex',
        'fontFamily': 'body',
        'fontSize': BNPL_PDP_MESSAGING_FONT_SIZE,
        'fontWeight': 'normal',
        'justifyContent': 'flex-start',
        'lineHeight': '120%',
        'minHeight': LOGO_HEIGHT,
        'width': '100%',
        [inPdpPaymentMethods]: {
          'paddingLeft': '12px',
          'position': 'relative',
          '&::before': {
            backgroundColor: 'grayAlpha.90',
            borderRadius: '50%',
            content: '""',
            height: '4px',
            left: 0,
            position: 'absolute',
            top: '8px',
            width: '4px',
          },
        },
        [inCartFooter]: {
          'color': 'greyscale.100',
          'fontSize': FONT_SIZE,
          'justifyContent': {base: 'center', lg: 'flex-start'},
          'paddingLeft': 0,
          '&::before': {
            display: 'none',
          },
        },
        '& .zip-widget__wrapper': {
          marginLeft: 0,
          marginRight: 0,
          padding: 0,
          width: '100%',
          [inCartFooter]: {
            marginLeft: {base: 'auto', lg: '0'},
            marginRight: {base: 'auto', lg: '0'},
          },
        },
        '& .zip-container': {
          alignItems: 'center',
          display: 'inline-flex',
          flexWrap: 'wrap',
          gap: '2px',
          justifyContent: 'flex-start',
          lineHeight: '120%',
          margin: 0,
          width: '100%',
        },
        '& .zip-container span': {
          fontSize: BNPL_PDP_MESSAGING_FONT_SIZE,
          margin: 0,
          [inCartFooter]: {
            fontSize: FONT_SIZE,
          },
        },
        '& .zip-container strong, & .zip-container b': {
          fontWeight: 'normal',
        },
        '& .zip-container img': {
          height: INFO_ICON_SIZE,
          margin: 0,
          verticalAlign: 'middle',
          width: INFO_ICON_SIZE,
        },
        '& .zip-container img.zip-logo': {
          height: LOGO_HEIGHT,
          margin: '0 0 0 2px',
          maxHeight: LOGO_HEIGHT,
          verticalAlign: 'middle',
          width: 'auto',
        },
        '& .zip-container svg': {
          height: INFO_ICON_SIZE,
          margin: 0,
          verticalAlign: 'middle',
          width: INFO_ICON_SIZE,
        },
        '& .kl-zip-info-a11y-button': {
          alignItems: 'center',
          background: 'transparent',
          border: 0,
          color: 'inherit',
          cursor: 'pointer',
          display: 'inline-flex',
          font: 'inherit',
          fontSize: BNPL_PDP_MESSAGING_FONT_SIZE,
          height: LOGO_HEIGHT,
          justifyContent: 'center',
          lineHeight: 1,
          margin: 0,
          padding: 0,
          verticalAlign: 'middle',
          [inCartFooter]: {
            fontSize: FONT_SIZE,
          },
        },
        '& [data-kl-a11y-enhanced="true"]': A11Y_FOCUS_VISIBLE,
      },
    },
  },
};

export default BuyNowPayLaterMessaging;
